import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'ingsvArrayNumberSorting'
})
export class ArrayNumberSortPipe implements PipeTransform {
  transform(array: any, sortingFieldsWay = ''): any[] {
    if (!Array.isArray(array)) {
      return;
    }

    array.sort((a: any, b: any) => {
      let aNumber = a;
      let bNumber = b;

      switch (sortingFieldsWay) {
        case 'propertiesForm': {
          aNumber = a.value.inputData.propertyConfig.formSortingIndex;
          bNumber = b.value.inputData.propertyConfig.formSortingIndex;

          break;
        }
        case 'menuTable': {
          aNumber = a.menuTableSortingIndex;
          bNumber = b.menuTableSortingIndex;
          break;
        }
        default: break;
      }

      return aNumber - bNumber;
    });

    return array;
  }
}
